// angular imports
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// constant imports
import { WorkflowConstants } from '../../../../shared-workflow-module/_constants/worflow-constants';

@Component({
    selector: 'app-workflow-acct-step-update-in-review',
    templateUrl: './workflow-acct-step-update-in-review.component.html',
    styleUrls: ['./workflow-acct-step-update-in-review.component.scss']
})
export class WorkflowAcctStepUpdateInReviewComponent implements OnInit {
    @ViewChild('updateInReviewFromWorkflowEditorPopup', { static: false })
    updateInReviewFromWorkflowEditorPopup: DxPopupComponent;

    @Output() onClose = new EventEmitter<void>();
    @Output() onUpdateInbox = new EventEmitter<void>();
    @Output() onUpdateReview = new EventEmitter<void>();

    visible = false;

    updateActions: Array<any> = [];
    selectedUpdateAction: string;

    iconCancel = IconConstants.CANCEL;
    iconCheck = IconConstants.CHECK;

    ngOnInit() {
        this.updateActions = [
            {
                action: WorkflowConstants.ACCTINBOX,
                text: 'Place in Accountant Inbox'
            },
            {
                action: WorkflowConstants.ACCTINREVIEW,
                text: 'Place in Accountant Review'
            }
        ];
        this.selectedUpdateAction = WorkflowConstants.ACCTINBOX;

        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.updateInReviewFromWorkflowEditorPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeUpdateInReviewFromWorkflowEditor();
    }

    onOkClick(): void {
        if (this.selectedUpdateAction === WorkflowConstants.ACCTINBOX) {
            this.onUpdateInbox.emit();
        } else if (this.selectedUpdateAction === WorkflowConstants.ACCTINREVIEW) {
            this.onUpdateReview.emit();
        }

        this.closeUpdateInReviewFromWorkflowEditor();
    }

    onCancelClick(): void {
        this.closeUpdateInReviewFromWorkflowEditor();
    }

    private closeUpdateInReviewFromWorkflowEditor(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
